angular
    .module('quattro.core.alert', [
        'quattro.core.alert.service',
        'quattro.core.alert.directive',
    ]);
